import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
    resetProducts: null,
    getSelectedDiyReturn: ['data'],
    setSelectedDiyReturn: ['data'],
    getExpertReview: ['taxYear', 'viewModelId'],
    setExpertReview: ['data'],
    getAuditProtection: ['taxYear', 'viewModelId'],
    setAuditProtection: ['data'],
    getSelectedPresale: ['data'],
    setSelectedOte: ['data'],
    getSelectedOte: ['data'],
    setSelectedPresale: ['data'],
    getActivationCodes: ['taxYear', 'viewModelId', 'clientId'],
    setActivationCodes: ['data'],
    addDataRetrievalId: ['id'],
    removeDataRetrievalId: ['id'],
    getFiledReturn: ['taxYear', 'fileId', 'fileSource']
})

export const ProductTypes = Types
export default Creators

/* ------------- Initial State ------------- */
export const INITIAL_STATE = Immutable({
    products: [],
    selectedReturn: null,
    loadingReturn: false,
    selectedPresale: null,
    loadingPresale: false,
    selectedOte: null,
    loadingOte: false,
    activationCodes: null,
    dataRetrievalIds: [],
})

/* ------------- Reducers ------------- */
export const productResetProducts = (state) => INITIAL_STATE

export const productGetSelectedDiyReturn = (state) => {
    var selectReturn = {
        ...state.selectedReturn,
        loadingProductHistory: true
    }
    return state.merge({selectedReturn: selectReturn, activationCodes: null, loadingReturn: true})
}

export const productSetSelectedDiyReturn = (state, { data }) => {
    var selectedReturnData = data

    if (selectedReturnData) {
        selectedReturnData.returnStatuses =
            (selectedReturnData.returnStatuses || [])
                .map(obj => (Object.defineProperty(obj, 'isLoading', { value: false, writable: true, enumerable: true, configurable: true })))
    }

    return state.merge({ selectedReturn: selectedReturnData, loadingReturn: false })
}

export const productGetExpertReview = (state, { taxYear, viewModelId }) => {    	
     var selectReturn = { ...state.selectedProduct }    	
     return state.merge({ selectedProduct: selectReturn, loadingExpertReview: true })
}

export const productSetExpertReview = (state, { data }) => {	
    var selectReturn = { ...state.selectedProduct }	
    selectReturn.expertReview = data	
    return state.merge({ selectedProduct: selectReturn, loadingExpertReview: false })
}

export const productGetAuditProtection = (state) => {
    var selectReturn = { ...state.selectedProduct }
    return state.merge({ selectedProduct: selectReturn, loadingAuditProtection: true })
}

export const productSetAuditProtection = (state, { data }) => {
    var selectReturn = { ...state.selectedProduct }
    selectReturn.auditProtection = data
    return state.merge({ selectedProduct: selectReturn, loadingAuditProtection: false })
}

export const productSetSelectedPresaleSummary = (state, { data }) => {
    return state.merge({ selectedPresaleSummary: data});
}

export const productGetSelectedPresale = (state) => {
    return state.merge({ selectedPresale: null, loadingPresale: true });
}

export const productSetSelectedPresale = (state, { data }) => {
    return state.merge({ selectedPresale: data, loadingPresale: false });
}

export const productGetSelectedOte = (state, { data }) => {
    return state.merge({ selectedOte: null, loadingOte: true });
}

export const productSetSelectedOte = (state, { data }) => {
    return state.merge({ selectedOte: data, loadingOte: false });
}

export const productGetActivationCodes = (state, { data }) => {
    return state.merge({ activationCodes: null });
}

export const productSetActivationCodes = (state, { data }) => {
    return state.merge({ activationCodes: data || [] });
}

export const productAddDataRetrievalId = (state, { id }) => {
    var dataRetrieved = []
    for (var i = 0; i < state.dataRetrievalIds.length; i++) {
        dataRetrieved.push(state.dataRetrievalIds[i])
    }
    dataRetrieved.push(id);
    return state.merge({ dataRetrievalIds: dataRetrieved });
}

export const productRemoveDataRetrievalId = (state, { id }) => {
    var dataRetrieved = []
    for (var i = 0; i < state.dataRetrievalIds.length; i++) {
        dataRetrieved.push(state.dataRetrievalIds[i])
    }
    var filteredDataRetrieved = dataRetrieved.filter(function (e) { return e !== id})
    return state.merge({ dataRetrievalIds: filteredDataRetrieved });
}

export const productGetFiledReturn = (state, { taxYear, fileId, fileSource }) => {
    var dataRetrieved = []
    for (var i = 0; i < state.dataRetrievalIds.length; i++) {
        dataRetrieved.push(state.dataRetrievalIds[i])
    }
    dataRetrieved.push(fileId);
    return state.merge({ dataRetrievalIds: dataRetrieved });
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
    [Types.RESET_PRODUCTS]: productResetProducts,
    [Types.GET_SELECTED_DIY_RETURN]: productGetSelectedDiyReturn,
    [Types.SET_SELECTED_DIY_RETURN]: productSetSelectedDiyReturn,
    [Types.GET_EXPERT_REVIEW]: productGetExpertReview,
    [Types.SET_EXPERT_REVIEW]: productSetExpertReview,
    [Types.GET_AUDIT_PROTECTION]: productGetAuditProtection,
    [Types.SET_AUDIT_PROTECTION]: productSetAuditProtection,
    [Types.SET_SELECTED_PRESALE]: productSetSelectedPresale,
    [Types.GET_SELECTED_PRESALE]: productGetSelectedPresale,
    [Types.SET_SELECTED_OTE]: productSetSelectedOte,
    [Types.GET_SELECTED_OTE]: productGetSelectedOte,
    [Types.GET_ACTIVATION_CODES]: productGetActivationCodes,
    [Types.SET_ACTIVATION_CODES]: productSetActivationCodes,
    [Types.ADD_DATA_RETRIEVAL_ID]: productAddDataRetrievalId,
    [Types.REMOVE_DATA_RETRIEVAL_ID]: productRemoveDataRetrievalId,
    [Types.GET_FILED_RETURN]: productGetFiledReturn
})